import AbstractProvidedClass from "../shared/AbstractProvidedClass";

export default class Modal extends AbstractProvidedClass {
    constructor(provider) {
        super(provider);

        this.overlay = this.p.createDiv()
            .parent('#p5canvas')
            .class('modal-overlay' + (this.mobile ? ' modal-fullscreen' : ''));

        this.container = this.p.createDiv()
            .parent(this.overlay)
            .class('modal-container');

        this.header = this.p.createElement('header', '')
            .parent(this.container)
            .class('modal-header');

        this.content = this.p.createElement('section', '')
            .parent(this.container)
            .class("modal-content");

        this.footer = this.p.createDiv()
            .parent(this.container)
            .class('modal-footer');

        this.cancelButton = this.p.createButton('Cancel')
            .parent(this.footer)
            .class('btn-secondary mar-r-sm');

        this.button = this.p.createButton('')
            .parent(this.footer)
            .class('btn-primary');

        this.cancelButton.hide();
    }

    onClickOutside(func) {
        this.overlay.mousePressed((e) => {
            if (e.target.className.includes('modal-overlay')) {
                func();
            }
        })
        return this;
    }

    setTitle(headerText) {
        this.headerText = this.p.createElement('h3', headerText)
            .parent(this.header);
        return this;
    }

    addContent(content) {
        content.parent(this.content);
        return this;
    }

    setButtonText(buttonText) {
        this.button.html(buttonText);
        return this;
    }

    onClickCancel(func) {
        this.cancelButton.show();
        this.cancelButton.mousePressed(func);
        return this;
    }

    onClickButton(func) {
        this.button.mousePressed(func);
        return this;
    }

    hide() {
        this.overlay.hide();
    }

    show() {
        this.overlay.show();
        this.overlay.style('display', 'flex');
    }

    remove() {
        this.overlay.remove();
    }

    addClass(className) {
        this.overlay.addClass(className);
        return this;
    }

    removeClass(className) {
        this.overlay.removeClass(className);
        return this;
    }
}
